import { render, staticRenderFns } from "./admin-transactions-edit.vue?vue&type=template&id=38d27cbc"
import script from "./admin-transactions-edit.vue?vue&type=script&lang=js"
export * from "./admin-transactions-edit.vue?vue&type=script&lang=js"
import style0 from "./admin-transactions-edit.vue?vue&type=style&index=0&id=38d27cbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports